import {getConfig} from '../lib/config.ts';

const CACHE_PREFIX = 'hub-api:';

let currentCache: Cache | null = null;

type GetApiCacheOptions = Partial<{
  reset: boolean;
}>;
export async function getApiCache(options: GetApiCacheOptions = {}): Promise<Cache | null> {
  if (!window.caches) {
    return null;
  }

  const optionsWithDefaults = {
    reset: false,
    ...options,
  };

  if (currentCache === null || optionsWithDefaults.reset) {
    const currentCacheKey = makeCurrentCacheKey();
    await deleteOutdatedCaches(currentCacheKey);
    currentCache = await window.caches.open(currentCacheKey);
  }

  return currentCache;
}

function makeCurrentCacheKey(): string {
  const config = getConfig();
  const renderVersion = config.renderVersion || 'unspecified-version';
  return CACHE_PREFIX + renderVersion;
}

async function deleteOutdatedCaches(currentCacheKey: string): Promise<void> {
  const existingCacheKeys = await window.caches.keys();
  const deletionPromises = existingCacheKeys.filter((key) => key.startsWith(CACHE_PREFIX) && key !== currentCacheKey).map((key) => {
    console.debug(`Deleting outdated cache: ${key}`);
    return caches.delete(key);
  });
  await Promise.all(deletionPromises);
}
